import pegasus from "../../assets/scripts/global/01-pegasus";

document.addEventListener("alpine:init", () => {
    Alpine.data("navigation", (options) => ({
            scrolled: false,
            menuOpen: false,
            menu: null,
            mobSubMenu: null,
            visible: false,
            mobileBreakpoint: 'md',
            subNav: null,
            hasSubNav: false,
            lastScrollTop: 0,
            activeNestedItems: {},
            defaultNestedItems: {},
            searchIsOpen: false,
            searchTerm: '',
            navHidden: false,
            async init() {
                // Wait for Alpine teleport to move SubNav into place
                await pegasus.wait(200);
                
                // Check for SubNav after teleport has had time to work
                this.hasSubNav = document.getElementById('pegasus-subnav') !== null;

                //delay to allow for other scripts to load
                await pegasus.wait(200);

                this.initScrollHandling();

                this.$watch('menuOpen', (value) => {
                    const subNav = document.getElementById('subnav-target');
                    const currentMenu = document.querySelectorAll('[data-menu-id]');

                    if(!subNav) return;

                    if(value) {
                        subNav.classList.add('opacity-0');
                        currentMenu.forEach(menu => {
                            menu.style.transform = `translateY(-${subNav.offsetHeight}px)`;
                        });
                    } else {
                        subNav.classList.remove('opacity-0');
                        currentMenu.forEach(menu => {
                            menu.style.transform = `translateY(16px)`;
                        });
                    }
                });
                
                this.visible = true;
                
                const ipDetectionBar = document.querySelector('.ip-detection-bar');

                if (ipDetectionBar && ipDetectionBar instanceof Node) {
                    const pageContent = document.querySelector('#content');

                    const originalNavBarHeight = this.$refs.navBar.offsetHeight;
                    const originalPageContentPadding = pageContent instanceof HTMLElement ? parseInt(window.getComputedStyle(pageContent).paddingTop) || 0 : 0;

                    const mobNav = document.querySelector('.Navigation__mobile');

                    pegasus.onResizeFinished(() => {
                        let barHeight = ipDetectionBar.offsetHeight;
                        this.$refs.navBar.style.height = `${originalNavBarHeight + barHeight}px`;
                        if (pageContent instanceof HTMLElement) {
                            pageContent.style.paddingTop = `${originalPageContentPadding + barHeight}px`;
                        }
                        mobNav.style.top = `${originalNavBarHeight + barHeight}px`;
                    }, true);
                }
            },
            initScrollHandling() {
                window.addEventListener('scroll', () => {
                    let st = window.scrollY;

                    if ((st > this.lastScrollTop && st > 200) && !this.searchIsOpen) {
                        this.$el.classList.add('-hide-nav');
                        this.scrolled = false;
                        if (this.hasSubNav) {
                            this.$el.classList.add('-show-subnav-only');
                        }
                        this.navHidden = true;
                        window.dispatchEvent(new CustomEvent('nav-hiding'));
                    } else {
                        // Scrolling up
                        this.$el.classList.remove('-hide-nav', '-show-subnav-only');
                        this.scrolled = st !== 0 ? true : false;
                        
                        this.navHidden = false;
                        window.dispatchEvent(new CustomEvent('nav-showing'));
                    }

                    this.lastScrollTop = st;
                });
            },
            lockScroll() {
                document.getElementsByTagName("body")[0].style.overflow = "hidden";
            },
            unlockScroll() {
                document.getElementsByTagName("body")[0].style.overflow = "auto";
            },
            closeMenu() {
                const previousMenu = this.menu;
                this.menu = null;
                this.menuOpen = false;
                this.mobSubMenu = null;
                this.searchIsOpen = false;
                if (previousMenu) {
                    if (this.defaultNestedItems[previousMenu] !== undefined) {
                        this.activeNestedItems[previousMenu] = this.defaultNestedItems[previousMenu];
                    } else {
                        delete this.activeNestedItems[previousMenu];
                    }
                }
                this.unlockScroll();
            },
            toggleMenu(menuItemID) {
                if (this.menu == menuItemID) {
                    this.closeMenu();
                } else {
                    this.menu = menuItemID;
                    this.menuOpen = Boolean(this.menu);   
                    this.searchIsOpen = false;             
                    this.lockScroll();
                    this.ensureNestedItem(menuItemID);
                }             
            },
            registerNestedDefault(menuId, defaultIndex = null) {
                this.defaultNestedItems[menuId] = defaultIndex;
                this.ensureNestedItem(menuId);
            },
            ensureNestedItem(menuId) {
                if (this.activeNestedItems[menuId] === undefined) {
                    const defaultIndex = this.defaultNestedItems[menuId];
                    this.activeNestedItems[menuId] = defaultIndex !== undefined ? defaultIndex : null;
                }
            },
            getActiveNestedItem(menuId) {
                return this.activeNestedItems[menuId] ?? null;
            },
            isNestedItemActive(menuId, itemIndex) {
                return this.getActiveNestedItem(menuId) === itemIndex;
            },
            toggleNestedItem(menuId, itemIndex) {
                this.ensureNestedItem(menuId);

                if (this.isNestedItemActive(menuId, itemIndex)) {
                    this.activeNestedItems[menuId] = null;
                } else {
                    this.activeNestedItems[menuId] = itemIndex;
                }
            }
        }
    ));
});
